import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'

var swal = Swal;

$( document ).ready(function() {
    var isSend = false;
    $(".create-confirm").on("submit", function(e){
        if(!isSend){
            e.preventDefault();

            swal.fire({
                title: '¿Estás seguro que quieres actualizar los elementos?',
                text: 'Este registro alterará los registros anteriores',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#49d630',
                cancelButtonColor: '#dd3333',
                confirmButtonText: 'Sí, guardar'
            }).then((result) => {
                if (result.isConfirmed) {
                    isSend = true;
                    $(".create-confirm").trigger( "submit" );
                }else {
                    $(".btn-create-confirm").removeAttr('disabled');
                }
            })
        }
    });
});